import { dataReportBookmark } from 'dls-icons-data'
import { createIcon } from '../common'

const IconReportBookmark = /*#__PURE__*/createIcon(dataReportBookmark)
export default IconReportBookmark
